// SuccessPage.js
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useViewTransitionState } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faClock } from "@fortawesome/free-solid-svg-icons"; // Import the specific icon
import emailjs from 'emailjs-com';


import "./success.css";

const SuccessPage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      message: '',
    });
    const [email, setEmail] = useState();
    const [appId, setAppID] = useState();
    const [countdown, setCountdown] = useState(5); // Timer starting at 5 seconds
  
    const handleGoToAppointments = () => {
      navigate("/myappointment", { replace: true });
      window.location.reload();
    };
  
    const handleGoToHome = () => {
      navigate("", { replace: true });
      window.location.reload();
    };

    const sendEmail = (formData) => {
      emailjs.send(
        process.env.REACT_APP_SERVICE_ID,    // Replace with your EmailJS Service ID
        process.env.REACT_APP_TEMPLATE_ID,   // Replace with your EmailJS Template ID
        formData,             // Data from the form fields
        process.env.REACT_APP_PUBLIC_KEY     // Replace with your EmailJS Public Key
      )
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
      })
      .catch((error) => {
        console.error('FAILED...', error);
      });
    };

    useEffect(() => {
      const storedData = localStorage.getItem("appointment_detail_id");
      if (storedData) {
        const data = JSON.parse(storedData);
        setEmail(data.email);
        const formData = { email: data.email, name: data.name, message: data.appId };
        sendEmail(formData); // Send email once when the component mounts
        setAppID(data.appId);
        // console.log(data.email);
      }
    }, []); // Empty dependency array ensures this only runs once on mount
    
    useEffect(() => {
      // Countdown timer logic
      if (countdown > 0) {
        const timer = setTimeout(() => {
          setCountdown((prev) => prev - 1);
        }, 1000);
        return () => clearTimeout(timer);
      }
    }, [countdown]);
  
   /*  useEffect(() => {
      const storedData = localStorage.getItem("appointment_detail_id");
      if (storedData) {
        const data = JSON.parse(storedData);
        setEmail(data.email);
        const formdata = {email:data.email,name:data.name,message:data.appId};
        sendEmail(formData);
        setAppID(data.appId);
        console.log(data.email);
      }
  
      // Countdown timer with `setTimeout`
      const timer = setTimeout(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
  
      return () => clearTimeout(timer);
    }, [countdown]);  */// Re-run when `countdown` updates
  
    // Trigger navigation when countdown reaches 0
    useEffect(() => {
      if (countdown === 0) {
        navigate("/myappointment", { replace: true });
        window.location.reload();
      }
    }, [countdown, navigate]);
  
 /*  const navigate = useNavigate();

  const [email, setEmail] = useState();
  const [appId, setAppID] = useState();
  const [countdown, setCountdown] = useState(5); // Timer starting at 5 seconds

  const handleGoToAppointments = () => {
    navigate("/myappointment", { replace: true }); // Navigate to the appointment details page
  };

  const handleGoToHome = () => {
    navigate("", { replace: true }); // Navigate to the appointment details page
  };

  useEffect(() => {
    const storedData = localStorage.getItem("appointment_detail_id");
    if (storedData) {
      const data = JSON.parse(storedData);
      setEmail(data.email);
      setAppID(data.appId);
      console.log(data.email);
    }

    // const timer = setInterval(() => {
    //     setCountdown((prev) => prev - 1);
    // }, 1000);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer); // Clear timer when it reaches 0
          navigate("/myappointment", { replace: true }); // Navigate to the appointment details page
          return 0; // Return 0 to stop further updates
        }
        return prev - 1;
      });
    }, 1000);

    // if (countdown === 0) {
    //     navigate('/myappointment' , { replace: true });
    // }

    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, [navigate]); */

  return (
    <div className="success-container">
      <div className="icon-container">
        <FontAwesomeIcon icon={faCheckCircle} className="success-icon" />
      </div>
      <h1>Appointment Confirmed</h1>
      <p>Your appointment has been successfully booked!</p>
      <div className="details">
        <p>
          Your Email: <strong>{email}</strong>
        </p>
        <p>
          Your Appointment ID: <strong>{appId}</strong>
        </p>
      </div>
      <div className="redirecting-text">
        <span className="redirect-text">
          Redirecting to appointment details page in:
        </span>
        <div className="clock-container">
          <div className="clock">
            <div
              className="progress-bar"
              style={{ "--value": (countdown / 5) * 100 }} // Set progress based on countdown
            ></div>
            <div className="clock-time">{countdown}s</div>
          </div>
        </div>
      </div>

      <button className="btn" onClick={handleGoToAppointments}>
        My Appointment Details
      </button>
      <button onClick={handleGoToHome} className="mt-3 btn">
        Homepage
      </button>
    </div>
  );
};

export default SuccessPage;
